export type SsoAuthMethod = 'OIDC' | 'SAML2';

export type SsoDiscoverInfo = {
  organizationId: string;
  organizationName?: string;
  authMethod: SsoAuthMethod;
};

const COMPLETE_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const SSO_AUTO_EMAIL_KEY = 'dqfleet.ssoAutoEmail';

export function isCompleteEmail(email: string): boolean {
  return COMPLETE_EMAIL.test(email.trim());
}

export function buildSsoInitiateUrl(input: {
  organizationId: string;
  authMethod: SsoAuthMethod;
  email?: string;
  redirect?: string;
}): string {
  const org = encodeURIComponent(input.organizationId);
  const redirect = encodeURIComponent(input.redirect || '/');
  const hint = input.email?.trim()
    ? `&login_hint=${encodeURIComponent(input.email.trim())}`
    : '';

  if (input.authMethod === 'SAML2') {
    return `/api/auth/saml/${org}/initiate?RelayState=${redirect}`;
  }
  return `/api/auth/oidc/${org}/initiate?redirect=${redirect}${hint}`;
}

export function readSsoAutoEmail(): string | null {
  try {
    return sessionStorage.getItem(SSO_AUTO_EMAIL_KEY);
  } catch {
    return null;
  }
}

export function markSsoAutoEmail(email: string): void {
  try {
    sessionStorage.setItem(SSO_AUTO_EMAIL_KEY, email.trim().toLowerCase());
  } catch {
    // sessionStorage kan saknas (privat läge / tester)
  }
}

export function sameSsoAutoEmail(email: string): boolean {
  const stored = readSsoAutoEmail();
  if (!stored) return false;
  return stored === email.trim().toLowerCase();
}
